export const CHANGE_USERINFO: string = 'CHANGE_USERINFO';

export const START_LOADING: string = 'START_LOADING';
export const STOP_LOADING: string = 'STOP_LOADING';
export const SET_LOADING_TEXT: string = 'SET_LOADING_TEXT';

export const SET_RESERVATION_INFO: string = 'SET_ACTIVITY_INFO';
export const REMOVE_RESERVATION_INFO: string = 'REMOVE_ACTIVITY_INFO';
export const CHANGE_RESERVATION_STATUS: string = 'CHANGE_ACTIVITY_STATUS';

export const CLEAR_NEW_HISTORY: string = 'CLEAR_NEW_HISTORY';
export const SET_NEW_HISTORY: string = 'SET_NEW_HISTORY';
